module.exports = __webpack_public_path__ + "components/page-footer/static/meteo365__logo--white-0b0c55cd82fabead09261837e3b84452.png";